<template>
   <div class="text-input">
      <label><b>{{label}}</b></label>
      <div class="input-group">
        <input type='text' id="percentInput" class="form-control" v-model="displayValue" :disabled="disabled" @change="$emit('change')" @blur="updating=false" @focus="updating=true" :aria-label="{label}">
      </div>
      <div v-if="validator && validator.$error && validator.$dirty">
         <div class="error" v-for="(key, index) in Object.keys(validator.$params)" :key="key + index" >
           <div class="p-0 m-0" v-if="!validator[key]">{{ validatorMsgMap[key] }}</div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
  name: "PercentInput",
  props: {
     label: {
        type: String,
     },
     placeholder: {
        type: String,
     },
     disabled: {
        type: Boolean,
        default: false,
     },
     value: {
        type: [String, Number],
     },
     customStyles: {
         type: Object,
     },
     validatorMsgMap: {
         type: Object,
         default: null,
     },
     validator: {
         type: Object,
         default: null,
     }
  },
  data(){
    return{
      updating: false,
    }
  },
  computed: {
    displayValue: {
      get: function() {
          if (!this.value) return;
          if (this.updating) {
              // Cursor is inside the input field. unformat display value for user
              return this.value.toString()
          } else {
              // User is not modifying now. Format display value for user interface
              return this.value.toFixed(2)+ " %"
          }
      },
      set: function(modifiedValue) {
          // Recalculate value after ignoring "$" and "," in user input
          let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ""));
          // Ensure that it is not NaN
          if (isNaN(newValue)) {
              newValue = 0
          }
          // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
          // $emit the event so that parent component gets it
          this.$emit('input', newValue);
      }
    }
  }
  
}
</script>

<style lang="scss" scoped>
</style>
